import { Component } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-free-plan',
  templateUrl: './free-plan.component.html',
  styleUrl: './free-plan.component.css'
})
export class FreePlanComponent {
  load: boolean = false;
  plan: '';
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  constructor(private router: Router, private route: ActivatedRoute,private dataservice: CommonService, private _snackBar: MatSnackBar) {
    this.plan = this.route.snapshot.params.plan;
    console.log('this.plan');
    console.log(this.plan);
    this.purchasePlan();
  }
  purchasePlan(){
    this.load = false;
    const data = {
      plan: this.plan
    };
    this.dataservice.sendPostRequest('/api/purchase-free-plan', data).pipe(
      map((res: Response) => (res)))
      .subscribe(
        (response) => {
          console.log(response);
          this.load = true;
          localStorage.setItem('plan', this.plan);
          window.open('checkout_success?session_id=0&plan='+this.plan,'_self');
        },
        (error) => {
          this.load = true;
          console.log(error); 
          let err = error.error;
          let thisvar = this;
          Object.keys(err).forEach(key => {
              thisvar._snackBar.open(err[key], '', {
                duration: 3000,
                horizontalPosition: thisvar.horizontalPosition,
                verticalPosition: thisvar.verticalPosition,
              });
          });
        }
      );
  }
}
